<template>
  <div>
    <vue-tags-input :placeholder="pc || 'Tekan Enter untuk memasukan tag baru'" v-model="tag" :tags="tags" @tags-changed="(e) => { if(e.length) $emit('input', e.map(x=> x.text)) }" />
  </div>
</template>

<script>

export default {
  name: 'tag-input',
  props: {
    value: { required: true },
    pc: { type: String, required: false }
  },
  data () {
    return {
      tag: '',
      tags: [],
      errorList: false
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (to) {
        if (Array.isArray(to)) this.tags = to
      }
    }
  }
}
</script>

<style>
.vue-tags-input .ti-input {
    border: 1px solid #E4E6EF;
    border-radius: 0.42rem;
    padding: 0.65rem 1rem;
}
.vue-tags-input .ti-input .ti-tag.ti-valid{
    background-color: var(--primary-theme);
}
</style>



// WEBPACK FOOTER //
// src/base/component/tag-input.vue